module.exports = __webpack_public_path__ + "img/boy_bg.969bbe40.png";